/**
 * Gift Customization Module
 * Handles delivery date restrictions, gift message toggles, and character counters
 * and syncing gift fields to cart note.
 */

(function() {
  'use strict';

  /**
   * 1. Delivery date restriction (2 business days minimum)
   */
  function initDeliveryDateRestriction() {
    const dateInput = document.getElementById('preferred-delivery-date');
    
    if (!dateInput) return;

    const today = new Date();
    let minDate = new Date(today);
    let businessDays = 0;

    while (businessDays < 2) {
      minDate.setDate(minDate.getDate() + 1);
      if (minDate.getDay() !== 0 && minDate.getDay() !== 6) {
        businessDays++;
      }
    }

    dateInput.min = minDate.toISOString().split('T')[0];
  }

  /**
   * 2. Toggle gift message visibility
   */
    function initGiftMessageToggle() {

      const toggleRadios = document.querySelectorAll('input[name="gift_note_toggle"]');
      const messageField = document.querySelector('.gift-field--conditional');

      if (!toggleRadios.length || !messageField) return;

      toggleRadios.forEach(radio => {
        radio.addEventListener('change', () => {

          if (!radio.checked) return;

          if (radio.value === 'yes') {
            messageField.classList.add('is-active');
            messageField.hidden = false;
          } else {
            messageField.classList.remove('is-active');
            messageField.hidden = true;
          }

        });
      });
    }


  /**
   * 3. Character counters for textareas
   */
  function initCharacterCounters() {
    document.querySelectorAll('textarea[maxlength]').forEach(textarea => {
      // try next sibling, otherwise find common classes used in template
      let counter = textarea.nextElementSibling;
      if (!counter || !(counter.classList && (counter.classList.contains('character-counter') || counter.classList.contains('char-count')))) {
        counter = textarea.parentElement && textarea.parentElement.querySelector('.character-counter, .char-count');
      }

      if (!counter) return;

      // Set initial count
      counter.textContent = `${textarea.value.length} / ${textarea.maxLength}`;

      // Update on input
      textarea.addEventListener('input', () => {
        counter.textContent = `${textarea.value.length} / ${textarea.maxLength}`;
      });
    });
  }

  /**
   * Initialize all gift customization features
   */
  function init() {
    initDeliveryDateRestriction();
    initGiftMessageToggle();
    initCharacterCounters();
    initFormSync();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section reload (for theme editor)
  document.addEventListener('shopify:section:load', function(e) {
    // Check if the loaded section contains customization elements
    if (e.target.querySelector('[data-gift-customization]')) {
      init();
    }
  });

})();

  /**
   * 4. Sync gift fields to cart note on form submission
   */
  function initFormSync() {
    const cartForm = document.querySelector('form.cart');
    if (!cartForm) return;

    cartForm.addEventListener('submit', function(e) {
      // Only proceed if they selected "yes" for handwritten note
      const noteToggle = document.querySelector('input[name="gift_note_toggle"]:checked');
      if (!noteToggle || noteToggle.value === 'no') return;

      const deliveryDate = document.getElementById('preferred-delivery-date').value;
      const giftMessage = document.getElementById('gift-message').value;
      const cartNote = document.getElementById('CartSpecialInstructions');

      if (!cartNote) return;

      // Build gift info block
      let giftInfo = '\n--- Gift Details ---\n';
      if (deliveryDate) {
        giftInfo += `Preferred Delivery Date: ${deliveryDate}\n`;
      }
      giftInfo += `Handwritten Note: ${noteToggle.value === 'yes' ? 'Yes' : 'No'}\n`;
      if (giftMessage) {
        giftInfo += `Gift Message: ${giftMessage}\n`;
      }

      // Append to existing cart note
      cartNote.value = cartNote.value + giftInfo;
    });
  }